import { supabase } from './supabase';
import { toast } from 'react-hot-toast';

export async function setupInitialUsers() {
  try {
    console.log('Starting initial user setup...');
    
    // Check if admin user exists
    const { data: adminUsers, error: checkError } = await supabase
      .from('users')
      .select('*')
      .eq('role', 'admin');

    if (checkError) throw checkError;

    // Only create admin if no admin users exist
    if (!adminUsers || adminUsers.length === 0) {
      console.log('No admin user found, creating one...');
      
      // First try to sign in with default admin credentials
      const { data: signInData, error: signInError } = await supabase.auth.signInWithPassword({
        email: 'admin@example.com',
        password: 'admin123'
      });

      if (signInData.user) {
        // Admin exists but not in users table
        const { error: updateError } = await supabase
          .from('users')
          .upsert({
            id: signInData.user.id,
            email: 'admin@example.com',
            display_name: 'Admin User',
            role: 'admin',
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString()
          });

        if (updateError) throw updateError;
        console.log('Admin user record updated');
        return;
      }

      // If sign in fails with anything other than invalid credentials, throw error
      if (signInError && signInError.message !== 'Invalid login credentials') {
        throw signInError;
      }

      // Create new admin user
      const { data: authData, error: signUpError } = await supabase.auth.signUp({
        email: 'admin@example.com',
        password: 'admin123',
        options: {
          data: {
            display_name: 'Admin User',
            role: 'admin'
          }
        }
      });

      if (signUpError) {
        // Ignore "User already registered" error
        if (signUpError.message === 'User already registered') {
          console.log('Admin user already exists');
          return;
        }
        throw signUpError;
      }

      if (authData?.user) {
        // Wait a moment for the auth trigger to create the user record
        await new Promise(resolve => setTimeout(resolve, 1000));

        // Update the user record with admin role
        const { error: updateError } = await supabase
          .from('users')
          .update({
            role: 'admin',
            display_name: 'Admin User'
          })
          .eq('id', authData.user.id);

        if (updateError) throw updateError;
        
        console.log('Admin user created successfully');
      }
    } else {
      console.log('Admin user already exists');
    }

    console.log('Initial user setup completed');
  } catch (error: any) {
    // Only show error for unexpected errors
    if (!error.message.includes('already registered')) {
      console.error('Error in setupInitialUsers:', error);
      toast.error('Failed to setup initial users');
    }
  }
}